<template>
     <el-dialog class="examine-dialog" :title="costStatus==='2'?'审核':'查看'" :visible.sync="showExamine" width="65%" height="55%" :before-close="closeDialog">
        <div class="main-content">
            <div class="content">
                <div class="content-box">
                    <div><span class="content-title">{{headInfo.bidName}}</span> <span class="content-label">{{headInfo.costStatusText}}</span></div>
                    <div class="content-desc" v-if="headInfo.orderType!=='3'">
                    <span class="content-desc-item">订单号<span class="content-desc-cont">{{headInfo.orderNo}}</span></span>
                    <span class="content-desc-item">招标项目编号<span class="content-desc-cont">{{headInfo.bidNo}}</span></span>
                    <span class="content-desc-item">订单类型<span class="content-desc-cont">{{headInfo.orderTypeText}}</span></span>
                    <span class="content-desc-item">应缴金额<span class="content-desc-cont">{{headInfo.receivePayAmount}}</span></span>
                    <span class="content-desc-item">实缴金额<span class="content-desc-cont">{{headInfo.actualReceivePay}}</span></span>
                    <span class="content-desc-item">缴纳方式<span class="content-desc-cont">{{headInfo.payTypeText}}</span></span>
                    <span class="content-desc-item">下单时间<span class="content-desc-cont">{{headInfo.orderTime}}</span></span>
                    <span class="content-desc-item">付款时间<span class="content-desc-cont">{{headInfo.transactionTime}}</span></span>
                    </div>
                    <div class="content-desc" v-if="headInfo.orderType==='3'">
                   <span class="content-desc-item">退款单号<span class="content-desc-cont">{{headInfo.orderNo}}</span></span>
                    <span class="content-desc-item">招标项目编号<span class="content-desc-cont">{{headInfo.bidNo}}</span></span>
                    <span class="content-desc-item">原保证金缴纳金额<span class="content-desc-cont">{{headInfo.orginDepositAmount}}</span></span>
                    <span class="content-desc-item">罚扣款金额<span class="content-desc-cont">{{headInfo.penaltyAmount}}</span></span>
                    <span class="content-desc-item">转合同押金金额<span class="content-desc-cont">{{headInfo.depositContract}}</span></span>
                    <span class="content-desc-item">应退保证金金额<span class="content-desc-cont">{{headInfo.receiveRefundDeposit}}</span></span>
                    <span class="content-desc-item">实退保证金金额<span class="content-desc-cont">{{headInfo.actualReceivePay}}</span></span>
                    <span class="content-desc-item">开户银行<span class="content-desc-cont">{{headInfo.bankCode}}</span></span>
                        <span class="content-desc-item">
                            银行账号
                            <span class="content-desc-cont">{{headInfo.bankAccount}}</span>
                        </span>
                        <span class="content-desc-item">下单时间<span class="content-desc-cont">{{headInfo.orderTime}}</span></span>
                        <span class="content-desc-item">退款时间<span class="content-desc-cont">{{headInfo.transactionTime}}</span></span>
                    </div>
                </div>
            </div>
            <div class="tab1" v-if="headInfo.payType === '1'&&headInfo.orderType!=='3'">
                <div class="tab1-title">凭证（银行转账信息凭证）</div>
                <el-table :data="headInfo.bidModuleFiles"  style="width: 100%" class="tab1-title-table" border tooltip-effect='dark'>
                    <el-table-column prop="fileName" label="文件名称" align="center"></el-table-column>
                    <el-table-column prop="action" label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="actionFn(scope.row, '0')">预览</el-button>
                            <el-button type="text" size="mini" @click="actionFn(scope.row, '1')">下载</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="tab1" v-if="headInfo.orderType === '3'">
                <div class="tab1-title">退款申请函</div>
                <el-table :data="bidFileInfo" style="width: 100%" border tooltip-effect='dark' >
                     <el-table-column prop="fileName" label="文件名称" align="center">
                    </el-table-column>
                    <el-table-column label="操作" align="center" width="200">
                        <template slot-scope="scope">
                            <el-button size="mini" type="text" @click="refundActionFn(scope.row, '0')">预览</el-button>
                            <el-button size="mini" type="text" @click="refundActionFn(scope.row, '1')">下载</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
             <div class="tab1" v-if="headInfo.payType === '3'&&headInfo.orderType!=='3'">
            <div class="tab1-title">运费明细</div>
            <el-table :data="costDetails" style="width: 100%" border tooltip-effect='dark' >
                <el-table-column prop="relationOrderNo" label="未结单号" align="center"></el-table-column>
                <el-table-column prop="totalAmount" label="总金额" align="center"></el-table-column>
                <el-table-column prop="availableAmount" label="可用金额" align="center"></el-table-column>
                <el-table-column prop="transferAmount" label="转投标保证金金额" align="center"></el-table-column>
            </el-table>
            <div class="tab1-title" style="margin-top: 10px;">附件文档</div>
            <el-table :data="headInfo.bidModuleFiles || []" style="width: 100%" border tooltip-effect='dark' >
                <el-table-column show-overflow-tooltip prop="fileName" label="附件名称" align="center"></el-table-column>
                <el-table-column prop="updateTime" label="上传时间" align="center"></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="actionFn(scope.row, '0')">预览</el-button>
                        <el-button type="text" size="small" @click="actionFn(scope.row, '1')">下载</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        </div>
        <span slot="footer">
            <el-button @click="closeDialog">取 消</el-button>
            <el-button v-if="costStatus!=='3'" type="primary" @click="confirm" :loading="loadDetermine">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { filePreview } from '@/utils/filePreview.js';
import { getSupplierCostByBond, getSupplierCostDetails } from '../../../api/myBidding.js';
import { dictWithUrl } from '@/components/lots/api';
import { approval } from '../../../api/supplierBid.js';
import { moduleFile } from '../../../api/annoMana.js';
export default {
    props: {
        showExamine: {
            type: Boolean,
            default: false
        },
        id: {
            type: Number,
            default: 1
        },
        orderType: {
            type: String,
            default: '3'
        },
        costStatus: {
            type: String,
            default: ''
        },
        supplierName: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            loadDetermine: false,
            dictData: {}, // 数字字典
            headInfo: {},
            bidFileInfo: [],
            costDetails: [],
            refundAmount: 0
        };
    },
    mounted() {
        // 数字字典转换
        dictWithUrl('BID_EXPENSE_ORDER_TYPE,BID_PAY_TYPE,BID_COST_STATUS').then(res => {
            this.dictData = res.data;
            this.init();
        });
    },
    methods: {
        closeDialog() {
            this.$emit('update:showExamine', false); // 直接修改父组件的属性
        },
        async confirm() {
            this.loadDetermine = true;
            const res = await approval({ id: this.id });
            this.loadDetermine = false;
            if (res && res.code === '0') {
                this.$message({
                    showClose: true,
                    message: '审核成功',
                    type: 'success'
                });
                this.$emit('updateData');
                this.$emit('update:showExamine', false);
            }
        },
        init() {
            getSupplierCostByBond({ id: this.id, orderType: this.orderType }).then(res => {
                this.headInfo = res.data;
                this.refundAmount = this.sub(this.headInfo.actualReceivePay, this.headInfo.penaltyAmount);
                this.refundAmount = +this.headInfo.refundAmount ? this.sub(this.headInfo.refundAmount, this.headInfo.depositContract) : 0;
                this.conversionData(this.headInfo);
                getSupplierCostDetails({ orderNo: this.headInfo.orderNo }).then(res => {
                    this.costDetails = res.data.list;
                });
                if (this.headInfo.payType !== '2') {
                    const par = { moduleNo: this.headInfo.orderNo };
                    moduleFile(par).then(res => {
                        if (res.data) {
                            const listdata = res.data.list || [];
                            if (listdata.length > 1) {
                                const listdataForm = [...listdata];
                                listdataForm.forEach(el => {
                                    el.createTime = new Date(el.createTime).getTime();
                                });
                                const newtime = Math.max.apply(Math, listdataForm.map(function(o) { return o.createTime; }));
                                const data = listdataForm.find(el => {
                                    return el.createTime === newtime;
                                });
                                this.bidFileInfo = [];
                                this.bidFileInfo.push(data);
                            } else {
                                this.bidFileInfo = listdata;
                            }
                            // this.bidFileInfo = res.data.list;
                        }
                    });
                }
            });
        },
        conversionData(obj) {
            obj.orderTypeText = this.dictData.BID_EXPENSE_ORDER_TYPE[obj.orderType];
            obj.payTypeText = this.dictData.BID_PAY_TYPE[obj.payType];
            obj.costStatusText = this.dictData.BID_COST_STATUS[obj.costStatus];
        },
        actionFn(row, type, index) {
            if (type === '1') {
                window.open(row.fileUrl, '_parent');
            } else {
                filePreview(row);
            }
        },
        refundActionFn(row, type, index) {
            // 退款申请函 下载
            if (type === '1') {
                this.downLoad(row)
            } else {
                filePreview(row);
            }
        },
        // 通过ajax请求文件流修改文件名
        downLoad(row) {
            const xhr = new XMLHttpRequest();
            xhr.open('GET', row.fileUrl, true);
            xhr.responseType = 'blob';
            xhr.onload = () => {
                if (xhr.status === 200) {
                    const filename = '退款申请函' + (this.supplierName ? ('-' + this.supplierName) : '') + '.' + row.fileType
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(xhr.response, filename);
                    } else {
                        const link = document.createElement('a');
                        link.href = window.URL.createObjectURL(xhr.response);
                        link.download = filename;
                        link.click();
                        window.URL.revokeObjectURL(link.href);
                    }
                }
            };
            xhr.send();
        },
        sub(arg1, arg2) {
            // 减法精度处理
            let r1 = ''; let r2 = ''; let m = ''; let n = '';
            try { r1 = arg1.toString().split('.')[1].length; } catch (e) { r1 = 0; }
            try { r2 = arg2.toString().split('.')[1].length; } catch (e) { r2 = 0; }
            m = Math.pow(10, Math.max(r1, r2));
            n = (r1 >= r2) ? r1 : r2;
            return ((arg1 * m - arg2 * m) / m).toFixed(n);
        }
    }
};
</script>
<style lang="less">
.examine-dialog{
    .main-content {
        // height: 280px;
    }

    .content {
        display: flex;
        align-items: center;
        padding: 14px;
        margin: 10px;
        background: #F8F8F8;
        box-sizing: border-box;
        vertical-align: middle;

        .content-title {
            margin-bottom: 15px;
            font-size: 16px;
            font-weight: 700;
        }

        .content-label {
            display: inline-block;
            padding: 3px 6px;
            margin-left: 12px;
            color: #fff;
            background: #FF7C24;
            border-radius: 2px;
        }

        .content-desc {
            display: flex;
            margin-top: 15px;
            width: 100%;
            flex-wrap: wrap;
        }

        .content-desc-item {
            margin: 0 25px 4px 0;
            color: #888;
        }

        .content-desc-editor {
            margin-left: 10px;
            font-size: 14px;
            cursor: pointer;
        }

        .content-desc-cont {
            margin-left: 5px;
            color: #333;
        }
    }

    .tab1 {
        padding: 10px;

        .tab1-title {
            margin-bottom: 10px;
        }
    }
}
</style>